import { render, staticRenderFns } from "./casedetail.vue?vue&type=template&id=669ee5c9&scoped=true&"
import script from "./casedetail.vue?vue&type=script&lang=js&"
export * from "./casedetail.vue?vue&type=script&lang=js&"
import style0 from "./casedetail.vue?vue&type=style&index=0&id=669ee5c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669ee5c9",
  null
  
)

export default component.exports